// NotificationIcon.js

import React, {
    useEffect,
    useState,
    useRef,
    useCallback
} from "react";


import {
    IconButton,
    Badge,
    Avatar,
    Typography,
    Box,
    Fade,
    useMediaQuery,
    useTheme,
    ClickAwayListener
} from "@mui/material";


import {
    FaFacebookMessenger
} from "react-icons/fa";


import api from "../../api/api";


import ChatNotificationModal from "./ChatNotificationModal";



const NotificationIcon = () => {



/*
=================================
STATES
=================================
*/


const [
    notificationschat,
    setNotificationschat
] = useState([]);



const [
    unreadCountchat,
    setUnreadCountchat
] = useState(0);



const [
    modalOpenchat,
    setModalOpenchat
] = useState(false);



const [
    latestPopup,
    setLatestPopup
] = useState(null);



const [
    showPopup,
    setShowPopup
] = useState(false);





/*
=================================
REFS
=================================
*/


const isRefreshingRef =
    useRef(false);



const lastSeenId =
    useRef(null);



const audioRef =
    useRef(null);



const notificationRef =
    useRef(null);





/*
=================================
THEME / RESPONSIVE
=================================
*/


const theme =
    useTheme();



const isMobile =
    useMediaQuery(
        theme.breakpoints.down("sm")
    );





/*
=================================
FETCH CHAT NOTIFICATIONS
=================================
*/


const fetchNotifications =
useCallback(async()=>{


    if(
        isRefreshingRef.current
    )
        return;



    try{


        const response =
            await api.get(
                "/api/users/chat-notifications/"
            );



        const data =
            response.data.sort(
                (a,b)=>
                new Date(b.created_at)
                -
                new Date(a.created_at)
            );



        const unread =
            data.filter(
                item =>
                !item.is_read
            );



        setNotificationschat(
            data
        );



        setUnreadCountchat(
            unread.length
        );




        /*
        ===============================
        NEW MESSAGE POPUP
        ===============================
        */


        if(

            data.length > 0 &&

            !data[0].is_read &&

            data[0].id !== lastSeenId.current

        ){


            lastSeenId.current =
                data[0].id;



            setLatestPopup(
                data[0]
            );



            setShowPopup(
                true
            );




            if(audioRef.current){


                audioRef.current
                .play()
                .catch(
                    error =>
                    console.log(
                        "Audio blocked",
                        error
                    )
                );


            }




            setTimeout(()=>{


                setShowPopup(
                    false
                );


            },5000);



        }




    }
    catch(error){



        if(
            error.response?.status === 401
        ){


            isRefreshingRef.current =
                true;



            const timer =
                setInterval(()=>{


                    const token =
                        localStorage.getItem(
                            "access"
                        );



                    if(token){


                        isRefreshingRef.current =
                            false;



                        clearInterval(
                            timer
                        );



                        fetchNotifications();


                    }



                },1000);



        }
        else{


            console.error(
                "Chat notification error:",
                error
            );


        }


    }



},[]);






/*
=================================
MARK CHAT AS READ
=================================
*/


const markAsRead =
async(id)=>{


    try{


        await api.patch(

            `/api/users/chat-notifications/${id}/mark_as_read/`

        );



        const updated =
            notificationschat.map(
                item =>

                item.id === id

                ?

                {
                    ...item,
                    is_read:true
                }

                :

                item
            );



        setNotificationschat(
            updated
        );



        setUnreadCountchat(

            updated.filter(
                item =>
                !item.is_read
            ).length

        );



    }
    catch(error){


        console.error(
            "Mark read error:",
            error
        );


    }


};






/*
=================================
CLICK OUTSIDE HANDLER
=================================
*/


const handleOutsideClick =
(event)=>{


    if(

        notificationRef.current &&

        !notificationRef.current.contains(
            event.target
        )

    ){


        setModalOpenchat(
            false
        );


    }


};






/*
=================================
LOAD NOTIFICATIONS
=================================
*/


useEffect(()=>{


    fetchNotifications();



    const interval =
        setInterval(

            fetchNotifications,

            10000

        );



    document.addEventListener(
        "mousedown",
        handleOutsideClick
    );




    return ()=>{


        clearInterval(
            interval
        );


        document.removeEventListener(
            "mousedown",
            handleOutsideClick
        );


    };



},[
    fetchNotifications
]);

return (

    <Box
        ref={notificationRef}

        sx={{

            /*
            =================================
            FLEX LAYOUT
            Allows other notifications beside chat
            =================================
            */

            display:"flex",

            alignItems:"center",

            gap:1.5,

            position:"relative",

            zIndex:20

        }}

    >



        {/* 
        ==========================================
        CHAT NOTIFICATION ICON
        ==========================================
        */}



        <IconButton


            onClick={()=>{


                setModalOpenchat(
                    previous =>
                    !previous
                );


            }}



            aria-label="View chat notifications"



            sx={{


                width:48,

                height:48,


                borderRadius:"50%",



                background:
                "linear-gradient(145deg,#111,#2b2b2b)",



                border:
                "1px solid rgba(255,255,255,.15)",



                transition:
                "all .35s ease",



                position:"relative",



                "&:hover":{


                    background:
                    "linear-gradient(145deg,#ff6d00,#ff3d00)",



                    transform:
                    "translateY(-3px) scale(1.08)",



                    boxShadow:
                    "0 15px 35px rgba(255,109,0,.45)"


                }



            }}


        >



            <Badge


                badgeContent={
                    unreadCountchat
                }



                max={99}



                sx={{


                    "& .MuiBadge-badge":{


                        background:
                        "linear-gradient(135deg,#ff6d00,#ff3d00)",



                        color:"#fff",



                        fontWeight:900,



                        fontSize:11,



                        minWidth:22,



                        height:22,



                        borderRadius:"50%",



                        border:
                        "2px solid #111",



                        boxShadow:
                        "0 0 15px rgba(255,109,0,.9)"


                    }


                }}



            >



                <FaFacebookMessenger


                    size={25}



                    color={

                        unreadCountchat > 0

                        ?

                        "#ff9800"

                        :

                        "#ffffff"

                    }



                />



            </Badge>



        </IconButton>






        {/* 
        ==========================================
        CHAT DROPDOWN MODAL
        ONLY SHOW AFTER ICON CLICK
        ==========================================
        */}



        {
            modalOpenchat &&


            (

                <Box


                    sx={{


                        position:"absolute",



                        top:60,



                        right:0,



                        width:

                        isMobile

                        ?

                        "90vw"

                        :

                        390,



                        maxHeight:
                        520,



                        overflowY:
                        "auto",



                        borderRadius:
                        "20px",



                        background:
                        "linear-gradient(145deg,#111,#292929)",



                        border:
                        "1px solid rgba(255,255,255,.12)",



                        boxShadow:
                        "0 25px 70px rgba(0,0,0,.65)",



                        animation:
                        "slideDown .25s ease",



                        zIndex:9999,



                        "@keyframes slideDown":{


                            from:{


                                opacity:0,


                                transform:
                                "translateY(-15px)"

                            },


                            to:{


                                opacity:1,


                                transform:
                                "translateY(0)"

                            }


                        }



                    }}



                >



                    <ChatNotificationModal


                        notificationschat={
                            notificationschat
                        }



                        setNotifications={
                            setNotificationschat
                        }



                        setUnreadCount={
                            setUnreadCountchat
                        }



                        onClose={()=>{


                            setModalOpenchat(
                                false
                            );


                        }}



                        markAsRead={
                            markAsRead
                        }



                    />



                </Box>


            )

        }
       


        {/* 
        ==========================================
        PREMIUM NEW MESSAGE POPUP
        Appears only for NEW unread messages
        ==========================================
        */}



        {
            latestPopup &&


            (

                <Fade

                    in={
                        showPopup
                    }


                    timeout={350}

                >



                    <Box


                        onClick={()=>{


                            setModalOpenchat(
                                true
                            );


                            setShowPopup(
                                false
                            );


                        }}



                        sx={{



                            position:"absolute",



                            top:65,



                            right:0,



                            width:

                            isMobile

                            ?

                            "90vw"

                            :

                            370,



                            borderRadius:
                            "20px",



                            overflow:
                            "hidden",



                            cursor:
                            "pointer",



                            background:
                            "linear-gradient(145deg,#111,#292929)",



                            border:
                            "1px solid rgba(255,255,255,.15)",



                            boxShadow:
                            "0 25px 70px rgba(0,0,0,.7)",



                            zIndex:10000,



                            transition:
                            "all .35s ease",



                            "&:hover":{



                                transform:
                                "translateY(-5px) scale(1.03)",



                                boxShadow:
                                "0 30px 90px rgba(255,109,0,.4)"


                            }



                        }}



                    >




                        {/* 
                        ==================================
                        TITLE BAR
                        ==================================
                        */}



                        <Box


                            sx={{


                                px:2,


                                py:1.5,



                                display:"flex",



                                alignItems:"center",



                                gap:1.5,



                                background:
                                "linear-gradient(135deg,#ff6d00,#ff3d00)"



                            }}


                        >



                            <FaFacebookMessenger

                                size={22}

                                color="#fff"

                            />



                            <Typography


                                sx={{


                                    color:"#fff",


                                    fontWeight:900,


                                    fontSize:16,


                                    letterSpacing:.5


                                }}



                            >

                                New Chat Message

                            </Typography>



                        </Box>








                        {/* 
                        ==================================
                        MESSAGE CONTENT
                        ==================================
                        */}



                        <Box


                            sx={{


                                p:2,


                                display:"flex",


                                alignItems:"center",


                                gap:2


                            }}


                        >





                            {/* USER AVATAR */}



                            <Box


                                sx={{


                                    position:"relative"


                                }}


                            >



                                <Avatar


                                    src={
                                        latestPopup.sender_profile_image_url
                                    }



                                    sx={{


                                        width:58,


                                        height:58,



                                        border:
                                        "3px solid #ff6d00",



                                        background:
                                        "#424242",



                                        boxShadow:
                                        "0 0 20px rgba(255,109,0,.55)"


                                    }}



                                />





                                {/* ONLINE DOT */}



                                <Box


                                    sx={{



                                        position:"absolute",



                                        bottom:2,



                                        right:2,



                                        width:15,



                                        height:15,



                                        borderRadius:"50%",



                                        background:
                                        "#76ff03",



                                        border:
                                        "2px solid #111"


                                    }}



                                />



                            </Box>









                            {/* MESSAGE DETAILS */}



                            <Box


                                sx={{


                                    flex:1,


                                    overflow:"hidden"


                                }}



                            >




                                <Typography


                                    sx={{


                                        color:"#fff",


                                        fontWeight:900,


                                        fontSize:15


                                    }}



                                >


                                    {

                                        latestPopup.sender_name

                                        ||

                                        "Administrator"

                                    }



                                </Typography>






                                <Typography


                                    sx={{


                                        color:"#bdbdbd",


                                        fontSize:13,


                                        mt:.5,



                                        display:
                                        "-webkit-box",



                                        WebkitLineClamp:
                                        2,



                                        WebkitBoxOrient:
                                        "vertical",



                                        overflow:
                                        "hidden"


                                    }}



                                >



                                    {

                                        latestPopup.message

                                        ||

                                        "You received a new notification"

                                    }



                                </Typography>






                                <Typography


                                    sx={{


                                        color:"#ff9800",


                                        fontSize:11,


                                        fontWeight:800,


                                        mt:1


                                    }}



                                >

                                    Click to view conversation


                                </Typography>



                            </Box>





                        </Box>







                        {/* 
                        ==================================
                        CHAMELEON ACTIVITY BAR
                        ==================================
                        */}



                        <Box


                            sx={{


                                height:5,



                                background:
                                "linear-gradient(90deg,#76ff03,#00e676,#ffeb3b,#ff9800)"


                            }}



                        />




                    </Box>



                </Fade>


            )

        }







        {/* 
        ==========================================
        NOTIFICATION SOUND
        ==========================================
        */}



        <audio


            ref={
                audioRef
            }



            src="/notification.mp3"



            preload="auto"



        />



    </Box>


);



};



export default NotificationIcon;

